import React from 'react';
import Loadable from 'react-loadable';
import qs from 'qs';

import LoadableLoading from 'components/LoadableLoading';
import { IProps } from './interface';
import { getAvailableColumns, getFilterColumns } from './api';

export const path = '/chrona/visits';

/** Отметки дома за день - сразу третий шаг реестра (SERVICE-5428, «Все отметки за день»). */
export const getPath = (object: string, name: string, date: string) =>
  `${path}?${qs.stringify({ object, name, date })}`;

const PageChronaVisitList: React.FC<IProps> = (props) => {
  const loader = {
    page: () => import('./page'),
    i18n: () => import('./ru.json'),
    columns: getAvailableColumns,
    filters: getFilterColumns,
  };

  const LoadableMap = Loadable.Map({
    loader,
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return (
        <Page
          i18n={loaded.i18n}
          columns={loaded.columns}
          filters={loaded.filters[0].columns}
          {...props}
          {...loadedProps}
        />
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PageChronaVisitList;
